import { useEffect } from "react";
import Navbar from "../components/global-components/navbar-v4";
import PageHeader from "../components/global-components/page-header";
import ProductDetails from "../components/shop-components/shop-details";
import { PropertyEndpoint } from "../api";
import { usePropertyStore } from "../store/usePropertyStore";
import { useParams } from "react-router-dom";

const Product_Details = () => {
    const { id, type } = useParams();
    const { setDetailProperti } = usePropertyStore();

    useEffect(() => {
        const propertyEndpoint = new PropertyEndpoint();

        const getOneProperty = async () => {
            try {
                const response = await propertyEndpoint.getPropertyById(
					id,
					type
				);

                setDetailProperti(response);
            } catch (error) {
                console.error("Gagal mengambil properti:", error);
                setDetailProperti(null);
            }
        };

        if (id) {
            getOneProperty();
        }
    }, [id, type, setDetailProperti]);

    return (
        <div>
            <Navbar CustomClass="ltn__header-transparent gradient-color-2" />
            <PageHeader headertitle="Product Details" customclass="mb-0" />
            <br />
            <br />
            <ProductDetails />
        </div>
    );
};

export default Product_Details;
